export function quickToken(code: string, origin: string): string {
    try {
        const url = new URL(code);
        if (url.origin !== origin || url.pathname.toLowerCase() !== '/login/index' || url.username || url.password) return '';
        const values = new URLSearchParams(url.hash.slice(1));
        if (values.getAll('quick-login').length !== 1) return '';
        const token = values.get('quick-login') || '';
        return /^[a-fA-F0-9]{64}$/.test(token) ? token : '';
    } catch { return ''; }
}
